import MainLayout from '@/common/components/layouts/MainLayout';
import StatusTransitionList from '@/modules/FileDetail/components/statusTransition/StatusTransitionList.tsx';
import SummeryFile from '@/modules/FileDetail/components/summeryFile/SummeryFile';
import { Box } from 'styled-system/jsx';

export default () => (
  <MainLayout title="گذر وضعیت" header="titleHeader" hasBottomPadding>
    <StatusTransition />
  </MainLayout>
);

const StatusTransition = () => {
  return (
    <Box mt="90px">
      <SummeryFile />
      <Box mt="20px" display="flex" flexDirection="column" rowGap="14">
        <StatusTransitionList />
      </Box>
    </Box>
  );
};
